export default "__VITE_ASSET__BezUFCyb__"